/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesHOpenIcon20Solid = forwardRef('ArrowCollapseTrianglesHOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m12.537 4.786 3.976 3.977a1.75 1.75 0 0 1 0 2.474l-3.976 3.977c-.567.567-1.537.165-1.537-.637V5.423c0-.802.97-1.204 1.537-.637Z" }),
        React.createElement("path", { d: "m3.488 8.763 3.976-3.977C8.03 4.22 9 4.621 9 5.423v9.154c0 .802-.97 1.204-1.536.637l-3.976-3.977a1.75 1.75 0 0 1 0-2.474Z" })));
});
